export const CREDIT_TYPE_OPTIONS = [
  { value: 'LC', label: 'LC' },
  { value: 'OA', label: 'OA (Open Account)' },
  { value: 'COD', label: 'COD' },
] as const;

export const PAYMENT_TERM_OPTIONS = [
  { value: 'Net 30 Days', label: 'Net 30 Days' },
  { value: 'Net 60 Days', label: 'Net 60 Days' },
  { value: 'Advance 100%', label: 'Advance 100%' },
  { value: '50% Advance, 50% On Delivery', label: '50% Advance, 50% On Delivery' },
] as const;

/** Select sentinel — never persisted as the payment term value itself. */
export const PAYMENT_TERM_CUSTOM_VALUE = '__custom__';

export function isPresetPaymentTermOption(term: string | null | undefined): boolean {
  if (!term) return false;
  return PAYMENT_TERM_OPTIONS.some((opt) => opt.value === term);
}

export function advancePercentageForPaymentTerm(term: string): number {
  if (term === 'Advance 100%' || term === '100% Advance') return 100;
  if (term === '50% Advance, 50% On Delivery' || term === '50% Advance + 50% Before Delivery') return 50;
  // Custom terms like "40% advance..." — best-effort parse
  const m = term.match(/(\d{1,3})\s*%\s*(?:advance|adv)/i) || term.match(/(?:advance|adv)\s*(\d{1,3})\s*%/i);
  if (m) return Math.min(100, Math.max(0, parseInt(m[1], 10)));
  return 0;
}

export const INSURANCE_TERM_OPTIONS = [
  { value: 'Supplier Scope', label: 'Supplier Scope' },
  { value: 'Buyer Scope', label: 'Buyer Scope' },
] as const;

export const TAX_TERM_OPTIONS = [
  { value: 'GST Extra', label: 'GST Extra' },
  { value: 'VAT Included', label: 'VAT Included' },
  { value: 'No Tax', label: 'No Tax' },
] as const;

export const TRANSPORT_TERM_OPTIONS = [
  { value: 'By Sea', label: 'By Sea' },
  { value: 'By Air', label: 'By Air' },
  { value: 'By Road', label: 'By Road' },
] as const;

export const DELIVERY_TERM_OPTIONS = [
  { value: 'CIF Mumbai', label: 'CIF Mumbai' },
  { value: 'FOB Origin', label: 'FOB Origin' },
  { value: 'EXW', label: 'EXW' },
] as const;

export const PACKING_TERM_OPTIONS = [
  { value: 'Seaworthy Packing', label: 'Seaworthy Packing' },
  { value: 'Standard Packing', label: 'Standard Packing' },
] as const;

export const UOM_OPTIONS = [
  'Pcs',
  'Kgs',
  'Ltrs',
  'Mtrs',
  'Sets',
  'Rolls',
  'Drums',
  'Pairs',
] as const;

export const OFFERED_QUALITY_OPTIONS = [
  'Genuine',
  'OEM',
  'Equivalent',
  'Copy Parts',
  'Mixed',
  'Brand as requested',
  'Custom manufacture',
  'Unknown',
  'Not-Applicable',
  'Compatible',
  'Substitute Brand',
] as const;

